import React from "react";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Inertia } from "@inertiajs/inertia";
import { EditQuestion } from "@/Components/Questions/EditQuestion";
import LayoutIcon from "@/Components/LayoutIcon";
import { Teams as TeamsIcon } from "@/Icons";

export default function Edit({ question }) {
  return <EditQuestion question={question.data} showReporterSelect={false} />;
}

Edit.layout = (page) => {
  const question = page.props?.question?.data;

  const backAction = () => {
    const backUrl = route("agency.question");
    const previousUrl = page.props?.previous_url;
    const [previousPath] = previousUrl.split("?");

    if (backUrl === previousPath && window.history.length > 1) {
      window.history.back();
    } else {
      Inertia.visit(backUrl);
    }
  };

  return (
    <AppLayout title={`Edit activity ${question?.title}`}>
      <OrganizationLayout
        header="Edit activity"
        preamble={question?.title || "No question found"}
        backAction={{ label: "Back", callback: backAction }}
        icon={
          <LayoutIcon>
            <TeamsIcon size={40} className="text-black" />
          </LayoutIcon>
        }
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
